import {mutations} from './mutations';
import {actions} from './actions';
import {getters} from './getters';

const state = {
    selectedPeriod: 12,

    activityByWeek: [],
    healthMetrics: {
        panelistCount: 0,
        panelistSubscribedCount: 0,
        panelistSubscribedPercent: 0,
        panelistUnsubscribedCount: 0,
        panelistUnsubscribedPercent: 0,
        panelistBlacklistedCount: 0,
        panelistBlacklistedPercent: 0,
        invitedCount: 0,
        invitedPercent: 0,
        openedCount: 0,
        openedPercent: 0,
        startedCount: 0,
        startedPercent: 0,
        profileCount: 0,
        profilePercent: 0,
        quotaCount: 0,
        quotaPercent: 0,
        completedCount: 0,
        completedPercent: 0,
        terminatedCount: 0,
        terminatedPercent: 0,
        qualityCount: 0,
        qualityPercent: 0,
        duplicateCount: 0,
        duplicatePercent: 0,
        disqualifiedCount: 0,
        disqualifiedPercent: 0,
    },
    healthMetricsExpires: null,

    createdAt: null,
    loading: false,
};

export default {
    namespaced: true,

    state,
    getters,
    actions,
    mutations
}

